/**
 * @generated SignedSource<<3d301dad770ea42c3eb140ad8527fe8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BaselineVersionScaleDirection = "FEWER" | "MORE" | "%future added value";
export type BaselineVersionSource = "COPY" | "COPY_SCALED" | "TEMPLATE" | "%future added value";
export type BaselineVersionCompareQuery$variables = {
  projectId?: string | null;
};
export type BaselineVersionCompareQuery$data = {
  readonly viewer: {
    readonly component: string | null;
    readonly project: {
      readonly baselineVersions: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
        readonly isStandard: boolean | null;
        readonly isActive: boolean | null;
        readonly summary: {
          readonly revenue: number | null;
          readonly cost: number | null;
          readonly profit: number | null;
          readonly margin: number | null;
          readonly minutes: number | null;
        } | null;
        readonly origin: {
          readonly source: BaselineVersionSource | null;
          readonly scaleDirection: BaselineVersionScaleDirection | null;
          readonly scalePercent: number | null;
          readonly templateName: string | null;
          readonly templateDescription: string | null;
        } | null;
        readonly phaseTotals: ReadonlyArray<{
          readonly name: string | null;
          readonly minutes: number | null;
          readonly roleCount: number | null;
        }> | null;
      }> | null;
    } | null;
  } | null;
};
export type BaselineVersionCompareQuery = {
  variables: BaselineVersionCompareQuery$variables;
  response: BaselineVersionCompareQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "baseline_version_compare"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"baseline_version_compare\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "projectId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutes",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "BaselineVersion",
  "kind": "LinkedField",
  "name": "baselineVersions",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isStandard",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BaselineVersionSummary",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "revenue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "margin",
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BaselineVersionOrigin",
      "kind": "LinkedField",
      "name": "origin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "source",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scaleDirection",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scalePercent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateDescription",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BaselineVersionPhaseTotal",
      "kind": "LinkedField",
      "name": "phaseTotals",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roleCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BaselineVersionCompareQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BaselineVersionCompareQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d8e0baa55135543e4ca87e0271cf2b9",
    "id": null,
    "metadata": {},
    "name": "BaselineVersionCompareQuery",
    "operationKind": "query",
    "text": "query BaselineVersionCompareQuery(\n  $projectId: ID\n) {\n  viewer {\n    component(name: \"baseline_version_compare\")\n    project(internalId: $projectId) {\n      baselineVersions {\n        id\n        name\n        isStandard\n        isActive\n        summary {\n          revenue\n          cost\n          profit\n          margin\n          minutes\n        }\n        origin {\n          source\n          scaleDirection\n          scalePercent\n          templateName\n          templateDescription\n        }\n        phaseTotals {\n          name\n          minutes\n          roleCount\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe3b25fdcdef176f04686d3eddd46222";

export default node;
